type SelectionMap = Record<string, number | string | null | undefined>;
type SelectionArray = Array<number | string | null | undefined>;

export interface AutomarkingComparableSettings {
  automarkPresences: boolean;
  autoselectedPriceListsItemsIds?: SelectionMap | SelectionArray | null;
  autoselectedMealTypes?: SelectionMap | SelectionArray | null;
}

const selectionValues = (selection: SelectionMap | SelectionArray | null | undefined) => {
  if (!selection) {
    return [];
  }

  const values = Array.isArray(selection) ? selection : Object.values(selection);

  return values.filter((value) => value !== null && value !== undefined && value !== "");
};

const hasAnySelection = (settings: AutomarkingComparableSettings): boolean => {
  if (selectionValues(settings.autoselectedPriceListsItemsIds).length > 0) {
    return true;
  }

  return selectionValues(settings.autoselectedMealTypes).length > 0;
};

const selectionKey = (settings: AutomarkingComparableSettings): string => {
  const values = [
    ...selectionValues(settings.autoselectedPriceListsItemsIds),
    ...selectionValues(settings.autoselectedMealTypes),
  ];

  return values
    .map((value) => String(value))
    .sort()
    .join(",");
};

// Returns true when the parent is about to activate automarking for the first time,
// re-enable it after it was off, or change which meals are auto-ordered.
// Saving unrelated fields (e.g. card number) while automarking stays untouched must not trigger it.
export const shouldConfirmAutomarkingActivation = (
  previous: AutomarkingComparableSettings | null,
  next: AutomarkingComparableSettings,
): boolean => {
  if (!next.automarkPresences) {
    return false;
  }

  if (!hasAnySelection(next)) {
    return false;
  }

  if (!previous) {
    return true;
  }

  if (!previous.automarkPresences) {
    return true;
  }

  return selectionKey(previous) !== selectionKey(next);
};
